import { Box, Button, Card, Grid, IconButton, Typography, CardContent,
  Stack,
  Dialog,
  DialogTitle,DialogContent } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import showToast from "../../../components/Hot-Toast/showToast";
import { customStep, emptyJob, previousStep } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";
import StaffingSolution from "./staffingSolution";
import AddJobPrice from "./addJobPrice";
import JobDescription from "./jobDescription";
import JobResponsibility from "./jobReponsibility";
import JobTitle from "./jobTitle";
import SelectJobCommission from "./selectJobCommission";
import ViewJobDetails from "./viewJobDetails";
import JobSpecialty from './jobSpecialty';
import JobContractType from './jobContractType';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import CloseIcon from "@mui/icons-material/Close";

export const MultiStepJobPost = () => {
    const mobileMedia = useMediaQuery({ maxWidth: 576 })
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }))
        const { mutateAsync:mutateAsyncSignature} = useTMutation("/job/uploadSignatureByFacility", "post", (data => { return data }))
    const { step, jobData } = useSelector((state) => state.job);
    const appliedAplicants = jobData?.cliniciansInFacilityJobShifts?.length;
    const initialStep = jobData?.HIRING_TYPE === "Self Hire" ? 2 : 0;
    console.log("step: ", step, " initialStep: ", initialStep, " jobData: ", jobData);
 const [openSignature, setOpenSignature] = useState(false);
  const sigCanvas = useRef(null);
  const [signature, setSignature] = useState(null);
  const { userDetails } = useSelector(state => state.user);

const saveSignature = async () => {
  if (sigCanvas.current) {
    const signatureDataUrl = sigCanvas.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    setSignature(signatureDataUrl);
    setOpenSignature(false);

    try {
      // Convert base64 to blob
      const byteString = atob(signatureDataUrl.split(",")[1]);
      const mimeString = signatureDataUrl.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });

      // Create file from blob
      const file = new File([blob], "signature.png", { type: mimeString });

      // Prepare form data
      const formData = new FormData();
      formData.append("file", file);
      formData.append("JOB_ID", jobData.ID);
      formData.append("USER_ID", userDetails?.ID);

      const response = await mutateAsyncSignature(formData);


      if (response.STATUS) {
      showToast(response.STATUS ? "success" : "error", response.MESSAGE, 3000);
      }
    } catch (error) {
      console.error("Validation Request failed:", error.message);
      showToast("error", "Something went wrong, Please try again", 3000);
    }
  }
};


    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const confirmationMessage = "You have unsaved changes. If you leave, your progress will be lost.";
            event.returnValue = confirmationMessage;
            return confirmationMessage;
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    const onSubmit = async () => {
        try {
            const response = await mutateAsync({ JOB_STATUS: "Open for Applications", ID: jobData.ID, });
            showToast(response.STATUS ? "success" : "error", response.MESSAGE, 3000);
            if (response.STATUS) {
                dispatch(emptyJob());
                navigate("/facility/jobs")
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    }
    const renderStepComponent = useMemo(() => {
        switch (step) {
            case 0: return <StaffingSolution />;
            case 1: return <SelectJobCommission />;
            case 2: return <JobContractType />;  //Self Hiring Start from Here
            case 3: return <AddJobPrice />;
            case 4: return <JobTitle />;
            case 5: return <JobSpecialty />;
            case 6: return <JobResponsibility />;
            case 7: return <JobDescription />;
            case 8: return <ViewJobDetails />;
            default: return null;
        }
    }, [step]);

    console.log("step , initialStep", step, initialStep);

    return (
        <>
            <Grid container >
                <>
                    <Grid lg={6} style={mobileMedia ? { paddingTop: 20 } : { marginTop: 10 }}>

                        {(jobData?.INITIALSTEP !== 8) ?
                            <Box
                                onClick={() => {
                                    if (appliedAplicants > 0 && step !== 8) {
                                        dispatch(customStep(8));
                                    }
                                    // step === 8 ? navigate("/facility/jobs") : navigate(-1); <=
                                    else if (step === 8 || step === initialStep) {
                                        navigate("/facility/jobs"); // Navigate back to the jobs page
                                    }
                                    else if (step === 2 && initialStep === 0 && jobData.STAFFING_SOLUTION !== "DirectHire") {
                                        dispatch(customStep(0)); // Skip back to step 0
                                    }
                                    else if (step === 3 && initialStep === 0 && jobData.STAFFING_SOLUTION === "DirectHire") {
                                        dispatch(customStep(1)); // Skip back to step 0
                                    }
                                    else if (jobData.REDIRECT) {
                                        dispatch(customStep(8)); // Return to preview when editing a section from step 8
                                    }
                                    else {
                                        dispatch(previousStep()); // Go to the previous step
                                    }
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start', // Ensures the position remains consistent
                                    cursor: 'pointer',
                                    gap: 1, // Adds spacing between the icon and text
                                    // width: '100%', // Ensures it adapts to container width
                                    padding: '8px 16px', // Adjusts padding for consistent spacing
                                    position: "fixed",
                                    top: "70px",
                                    left: "16px"
                                }}
                            >
                                <IconButton>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        whiteSpace: 'nowrap', // Prevents text from wrapping
                                        overflow: 'hidden', // Ensures no content overflow
                                        textOverflow: 'ellipsis', // Truncates long text with an ellipsis
                                    }}
                                >
                                    {/* {step === 8 || step === initialStep ? 'Cancel' : 'Back'} */}
                                    {step === 8 || step === initialStep ? 'Back' : ''}
                                    {/* if step is equal to  initialStep then Show cancel else "back" */}
                                </Typography>
                            </Box>
                            :
                            <Box
                                onClick={() => {
                                    navigate("/facility/jobs"); // Navigate back to the jobs page

                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start', // Ensures the position remains consistent
                                    cursor: 'pointer',
                                    gap: 1, // Adds spacing between the icon and text
                                    width: '100%', // Ensures it adapts to container width
                                    padding: '8px 16px', // Adjusts padding for consistent spacing
                                    position: "fixed",
                                    top: "70px",
                                    left: "16px"
                                }}
                            >
                                <IconButton>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        whiteSpace: 'nowrap', // Prevents text from wrapping
                                        overflow: 'hidden', // Ensures no content overflow
                                        textOverflow: 'ellipsis', // Truncates long text with an ellipsis
                                    }}
                                >
                                    Cancel

                                </Typography>
                            </Box>
                        }
                    </Grid>

                    <Grid container style={{ justifyContent: "center" }} mb={2}
                        mt={6}
                    >
                        <Grid item
                            lg={step === 8 ? 9 : (step === 6 || step === 7) ? 7 : 5.5}
                            sx={{ width: "auto", background: "transparent" }}>
                            <Box px={4} sx={{ cursor: "pointer" }}>
                            </Box>
                            <Card style={step === 8
                                ? { background: "transparent", boxShadow: "none", }
                                : (step === 6 || step === 7)
                                    ? { width: "100%", margin: "0 auto", boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" }
                                    : {}}>
                                <>
                                    {step > jobData?.INITIALSTEP && !jobData.REDIRECT && <Button
                                        onClick={() => !(step === 2 && jobData.STAFFING_SOLUTION !== "DirectHire") ? dispatch(previousStep()) : dispatch(customStep(0))}

                                        sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
                                    >
                                    </Button>
                                    }
                                    {renderStepComponent}
                                </>
                            </Card>
                        </Grid>
                    </Grid>



                    {step === 8 && jobData.JOB_STATUS === "Draft Application" &&
                        // <Box style={{ backgroundColor: "#ffffff", minHeight: "20vh", position: "fixed", bottom: 0, marginTop: "20px", left: 150 }}>
                        <Grid container mt={6}>
                            <Grid item xs={12} sm={12}  >
                                <Card
                                    // sx={{ width: "100%", maxWidth:"1100px", mx: "auto",height:"20vh" }}
                                    sx={{
                                        position: "fixed", // Fixes the card in place
                                        top: "90.5%", // Centers vertically
                                        left: "50%", // Centers horizontally
                                        transform: "translate(-50%, -50%)", // Ensures perfect centering
                                        width: "100%",
                                        maxWidth: "1100px",
                                        p: 2,
                                        zIndex: 1000, // Keeps it on top of other content
                                        background: "#fff", // Ensure background visibility
                                        boxShadow: 3, // Adds shadow for better visibility
                                    }}
                                >
                                    <CardContent>
      <Typography pt={1} style={{ fontWeight: 400, fontSize: "18px" }}>
        By selecting <span style={{ fontWeight: 500, fontSize: "18px"}}>Confirm</span>, 
        you agree that this job post reflects your requirements, and agree it will be posted and 
        applications will be processed following EmpowerCare’s Terms, Cookie, and Privacy Policies.
      </Typography>

      <Stack spacing={2} px={8} mt={2} direction="row" justifyContent="end" alignItems="center">

        {/* Upload Signature Button */}
        <Button
          variant="outlined"
          style={{ border: "1px solid #E2E8F0", color: "#4eb3e8" }}
          onClick={() => setOpenSignature(true)}
        >
          Upload Signature
        </Button>

        <Button
          style={{ border: "1px solid #E2E8F0", color: "#4eb3e8" }}
          onClick={() => {
            dispatch(emptyJob());
            navigate("/facility/jobs");
          }}
        >
          Save As Draft
        </Button>

        <Button
          className="gradientThemeColors"
          style={{ color: "#6ebe44", border: "1px solid #E2E8F0" }}
          onClick={onSubmit}
        >
          Confirm
        </Button>
      </Stack>

      {/* Show Signature Preview if available
      {signature && (
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          <Typography variant="subtitle2">Your Signature:</Typography>
          <img src={signature} alt="Signature" style={{ width: "200px", border: "1px solid #ccc" }} />
        </div>
      )} */}

      {/* Signature Dialog */}
      <Dialog open={openSignature} maxWidth="sm" fullWidth>
        <DialogTitle>
          Sign Here
          <IconButton
            aria-label="close"
            onClick={() => setOpenSignature(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 500, height: 200, className: "sigCanvas" }}
          />
          <Stack direction="row" justifyContent="end" spacing={2} mt={2}>
            <Button onClick={() => sigCanvas.current.clear()}>Clear</Button>
            <Button variant="contained" onClick={saveSignature}>Save</Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </CardContent>
                                </Card>
                            </Grid>

                        </Grid>
                        // </Box>
                    }
                </>

            </Grid>


        </>



    )


}

